import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAoPvgKfFpiWMvzLZP88ISBP3N90MVAFOY",
  authDomain: "guidance-wing.firebaseapp.com",
  projectId: "guidance-wing",
  storageBucket: "guidance-wing.firebasestorage.app",
  messagingSenderId: "124890260242",
  appId: "1:124890260242:web:9faaf365a9e80d010dc9cb"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Firestore helpers — read/write config data
export async function storageGet(key, fallback) {
  try {
    const snap = await getDoc(doc(db, "config", key));
    if (snap.exists()) return snap.data().value;
    return fallback;
  } catch (e) {
    console.error("Firestore read error:", e);
    return fallback;
  }
}

export async function storageSet(key, val) {
  try {
    await setDoc(doc(db, "config", key), { value: val, updatedAt: new Date().toISOString() });
  } catch (e) {
    console.error("Firestore write error:", e);
  }
}

// ─── Cloudinary File Upload ───
const CLOUD_NAME = "dejnub3ks";
const UPLOAD_PRESET = "gwcc_uploads";

export async function uploadFile(file) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);
    formData.append("folder", "guidance-wing");

    const isPdf = file.name.toLowerCase().endsWith('.pdf') || file.type === 'application/pdf';
    const isImage = file.type.startsWith("image/");

    // PDFs upload as "image" type (Cloudinary can handle PDFs as images)
    // Images upload as "image", everything else as "raw"
    const resourceType = (isPdf || isImage) ? "image" : "raw";

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`,
      { method: "POST", body: formData }
    );

    if (!res.ok) {
      const errData = await res.json();
      console.error("Cloudinary error:", errData);
      return null;
    }

    const data = await res.json();

    // For PDFs uploaded as image type, the secure_url ends with .pdf
    // and can be viewed directly in browser
    return {
      url: data.secure_url,
      downloadUrl: data.secure_url,
      publicId: data.public_id,
      format: data.format,
      size: data.bytes,
      originalName: file.name,
      isPdf: isPdf
    };
  } catch (e) {
    console.error("Upload error:", e);
    return null;
  }
}

export { db };
